/**
 * @generated SignedSource<<674a7a75f75a975b9b8de1f2bd1c46f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoFooterCircleStatus_todo$data = {
  readonly canChangeStatus: boolean;
  readonly expireAtDate: {
    readonly isoString: string;
  } | null;
  readonly id: string;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoFooterCircleStatus_todo";
};
export type TodoFooterCircleStatus_todo$key = {
  readonly " $data"?: TodoFooterCircleStatus_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoFooterCircleStatus_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoFooterCircleStatus_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "4950457bcf6fd0e09c95fd51b417aaa6";

export default node;
